import React, { useEffect, useState } from "react";
import styles from "./ekycSession.module.scss";
import axios from "axios";
import Dialog from "@mui/material/Dialog";

import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import ScheduleEkyc from "./scheduleEkyc";
import Images from "assets/Images";
import OnholdEkyc from "./onholdEkyc";
import RejectedEkyc from "./rejectedEkyc";
import VerifiedEkyc from "./verifiedEkyc";
import { IconButton } from "@mui/material";

const EkycSession = ({ token }) => {
  const session_id = crypto.randomUUID().replace(/-/g, "");
  const roomName = `eKYC-verification`;
  const ekycLink = `${window.location.protocol}//${window.location.hostname}:${window.location.port}/session-room?type=ekyc&room=${roomName}&session=${session_id}`;
  const [questions, setQuestions] = useState([]);
  const [value, setValue] = React.useState("1");
  const [loading, setLoading] = useState(false);
   const [ekycData, setEkycData] = useState([{
    id: 1,
    topic: "eKYC verification",
    start_time: "2025-09-05 10:00 AM",
     end_time: "2025-09-05 11:00 AM",
    timezone: "IST",
    ekycLink: ekycLink,
    status: "Pending",
    room_name: "ekyc-verification",
  }]);

 const [EkycsData, setEkycsData] = useState([
  {
    id: 1,
    topic: "eKYC 1",
    date_time: "2025-09-05 10:00 AM",
    timezone: "IST",
    ekycLink: ekycLink,
    status: "Verified",
    room_name: "room-1",
  },
  {
    id: 2,
    topic: "eKYC 2",
    date_time: "2025-09-05 02:30 PM",
    timezone: "IST",
    ekycLink:ekycLink,
    status: "On Hold",
    room_name: "room-2",
  },
  {
    id: 3,
    topic: "eKYC 3",
    date_time: "2025-09-06 11:15 AM",
    timezone: "IST",
    ekycLink: ekycLink,
    status: "Rejected",
    room_name: "room-3",
  },
  {
    id: 4,
    topic: "eKYC 4",
    date_time: "2025-09-07 04:45 PM",
    timezone: "IST",
    ekycLink: ekycLink,
    status: "Verified",
    room_name: "room-4",
  },
  {
    id: 5,
    topic: "eKYC 5",
    date_time: "2025-09-08 09:30 AM",
    timezone: "IST",
    ekycLink: ekycLink,
    status: "On Hold",
    room_name: "room-5",
  },
]);

  const [header, setHeader] = useState(false);
  const [ekycUrl, setEkycUrl] = useState('');
  const [copied, setCopied] = useState(false);
  const handleChangeTabs = (event, newValue) => {
    setValue(newValue);
  };
  const [open, setOpen] = React.useState(false);
  const [openCopyMeetingLink, setOpenCopyMeetingLink] = React.useState(false);
  const handleClickOpen = (mode, values) => {
    if (mode == "edit") {
      setHeader("Edit");
    }
    if (mode == "create") {
      setHeader("Schedule");
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
  }, []);
  const handleSubmit = (values) => {
    const roomName = `eKYC-${Date.now()}`;
    const ekycLink = `${window.location.protocol}//${window.location.hostname}:${window.location.port}/session-room?type=ekyc&room=${roomName}&session=${session_id}`;
    const [hours, minutes] = values.start_time.split(":").map(Number);
    const startDateTime = new Date(values.date);
    startDateTime.setHours(hours, minutes, 0, 0); // hours, minutes, seconds, ms

    const durationMinutes = parseInt(values.durationHr) * 60 + parseInt(values.durationMin);
    const endDateTime = new Date(startDateTime.getTime() + durationMinutes * 60000);

    const start_timestamp = startDateTime.toISOString();
    const end_timestamp = endDateTime.toISOString();
    const newEkyc = {
      id: Date.now(),
      topic: values.topic,
      start_time: start_timestamp,
      end_time: end_timestamp,
      timezone: values.timezone,
      ekycLink: ekycLink,
      status: "Pending",
      room_name: roomName,
      session_id:session_id
    };
    console.log("newEkyc",newEkyc)
    setEkycData((prev) => [...prev, newEkyc]);
    setOpen(false);
  };

  const getCustomerLink = (ekycLink) => {
    setEkycUrl(ekycLink)
    setOpenCopyMeetingLink(true)
  }
  const handleCloseCopyLink = () => {
    setOpenCopyMeetingLink(false)
  }
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(ekycUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset after 2s
    } catch (err) {
      console.error("Failed to copy!", err);
    }
  };
  return (
    <div className={styles.ekycWrapper}>
      <Dialog open={openCopyMeetingLink} onClose={handleCloseCopyLink}>
        <div className={styles.copytoClipboard}>
          <h5>Copy Meeting Link</h5>
          <IconButton
            className={styles.closeIcon} aria-label="close"
            onClick={handleCloseCopyLink}>
            <img src={Images.CLOSE} alt="Close" width="12" />
          </IconButton>
          <p>{ekycUrl}</p>
          <div className={styles.btnCont}>
            <button onClick={handleCopy}>
              {copied ? "Copied!" : "Copy to Clipboard"}
            </button>
          </div>
        </div>
      </Dialog>
      <Dialog open={open} onClose={handleClose}>
        <ScheduleEkyc handleClose={handleClose} handleSubmit={handleSubmit} />
      </Dialog>
      <div className={`rounded allEkyc ${styles.allEkyc}`}>
        <div className={styles.header}>
          <h3 className="text-lg font-semibold">eKYC</h3>
          <button onClick={() => handleClickOpen("create")}>Create eKYC</button>
        </div>
        <div className="tabMainContainer">
        <TabContext value={value}>
          <TabList
            onChange={handleChangeTabs}
            aria-label="lab API tabs example"
             variant="scrollable"       
            scrollButtons="auto"       
            allowScrollButtonsMobile
          >
            <Tab label="Scheduled eKYC" value="1" />
            <Tab label="Verified" value="2" />
            <Tab label="Rejected" value="3" />
            <Tab label="OnHold" value="4" />
          </TabList>

          <TabPanel value="1">
            {loading ? (
              <div className="flex justify-center items-center h-48">
                <p className={`text-gray-500 text-lg ${styles.gridLoaderContainer}`}>
                  <img src={Images.SPINNER} width="80" alt="Loading..." />
                </p>
              </div>
            ) : (
              <div className={styles.tableContainer}>
              <table className="w-full text-left border">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="p-2" width="200">
                      Topic
                    </th>
                    <th className="p-2" width="300">
                      Start Time
                    </th>
                      <th className="p-2" width="300">
                      End Time
                    </th>
                    <th className="p-2" width="200">
                      Time Zone
                    </th>
                    <th className="p-2" width="200">
                      Customer
                    </th>

                    {/* <th className="p-2">Score</th> */}
                    <th className="p-2">Status</th>
                    <th className="p-2" width="100">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {ekycData.map((ekyc) => (
                    <>
                      <tr key={ekyc.id} className="border-t">
                        <td className="p-2">{ekyc.topic}</td>
                     <td className="p-2">
                      {ekyc.start_time
                        ? new Date(ekyc.start_time).toLocaleString("en-US", {
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })
                        : "-"}
                    </td>
                        <td className="p-2">
                      {ekyc.end_time
                        ? new Date(ekyc.end_time).toLocaleString("en-US", {
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })
                        : "-"}
                    </td>
                        <td className="p-2">{ekyc.timezone}</td>
                        <td className="p-2">Customer &nbsp; {ekyc.status === "Pending" && <a style={{ cursor: 'pointer' }} onClick={() => getCustomerLink(ekyc.ekycLink)}><img src={Images.LINK} alt="Link" width="14" /></a>}</td>

                        <td className="p-2" style={{ whiteSpace: "nowrap" }}>{ekyc.status === "ONHOLD" ? "ON HOLD" : ekyc.status}</td>
                        <td className="p-2">
                          <ul className={styles.actionIcons}>
                            <li>
                              <a 
                              // onClick={() => handleEkyc(ekyc.id, 'edit')}
                               title="Edit">
                                <img src={Images.EDIT} alt="Edit" width="14" />
                              </a>
                            </li>
                            <li>
                              <a
                                // onClick={() => {
                                //   setSelectedQuestionId(ekyc.id);
                                //   handleDeletePopup();
                                // }}

                                className="text-red-600 hover:underline"
                              >
                                <img src={Images.TRASH} alt="Delete" width="16" />
                              </a>
                            </li>
                          </ul>
                        </td>
                      </tr>
                      <tr colSpan="6"></tr>
                    </>
                  ))}
                  {
                    ekycData.length == 0 &&
                    <tr className="border-t">
                      <td className="p-2" colSpan={7} style={{ textAlign: "center" }}>No data available</td>
                    </tr>
                  }
                  {/* */}
                </tbody>
              </table>
              </div>
            )}
          </TabPanel>
          <TabPanel value="2"><VerifiedEkyc VerifiedEkyc={EkycsData.filter(intv => intv.status === "Verified")} /></TabPanel>
          <TabPanel value="3"><RejectedEkyc RejectedEkyc={EkycsData.filter(intv => intv.status === "Rejected")} /></TabPanel>
          <TabPanel value="4"><OnholdEkyc onholdEkyc={EkycsData.filter(intv => intv.status === "On Hold")} /></TabPanel>
        </TabContext>
        </div>
      </div>
    </div>
  );
};

export default EkycSession;
